import React, { useContext } from 'react';
import InputConfig from '../../../../Components/InputConfig';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import PageHeading from '../../../../Components/PageHeading';
//mui imports====
import { Grid } from '@mui/material';
import useCommonStyles from '../../../../commonStyles';
import Paper from '@mui/material/Paper';

//===============

const BatchedAdRequestsConfig = ({ keyData , featureDescription}) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);
	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Batched Ad Requests"
				headingPath={['Dashboard', 'Framerate', 'Request Structure Data', 'Batched Ad Requests']}
				description="Manage ad request configuration."
				showInfoButton={true}
				infoMessage={featureDescription}
			/>
			<Grid container spacing={1} style={{ marginTop: '3rem', width: '90%', marginLeft: '4rem' }}>
				<Grid item xs={3}>
					<InputConfig
						label="Request Batch Size"
						keyData={keyData + '.requestBatchSize'}
						inputType="number"
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={3}>
					<InputConfig
						label="Batch Delay Time (ms)"
						keyData={keyData + '.batchDelayTimeInMs'}
						inputType="number"
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={3}>
					<InputConfig
						label="Request Section Size"
						keyData={keyData + '.requestSectionSize'}
						inputType="number"
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={3}>
					<InputConfig
						label="Section Delay Time (ms)"
						keyData={keyData + '.sectionDelayTimeInMs'}
						inputType="number"
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={3}>
					<InputConfig
						label="Filled Retry Interval"
						keyData={'requestStructureData.filledRetryInterval'}
						inputType="number"
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={3}>
					<InputConfig
						label="Unfilled Retry Interval"
						keyData={'requestStructureData.unfilledRetryInterval'}
						inputType="number"
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};
export default BatchedAdRequestsConfig;
